import { useEffect, useState } from 'react';

export const useResize = () => {
  const [deviceWidth, changeDeviceWidth] = useState(window.innerWidth);
  useEffect(() => {
    const resizeW = () => changeDeviceWidth(window.innerWidth);
    window.addEventListener('resize', resizeW);
    return () => window.removeEventListener('resize', resizeW);
  }, [deviceWidth]);

  return deviceWidth;
};
